import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import ReactTable from 'react-table';
import { _delete, get, put, postWithHeaders } from "../../../server/actions";
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import { _addNotification, _addNotificationError, groupBy, numberParce } from "../../../server/util";
import moment from 'moment';
import LeadDetails from "./leadDetails";
//import Datetime from 'react-datetime';
//import '../../../../node_modules/react-datetime/css/react-datetime.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './leadsManagement.css';
import { required, email, phone, isValidForm } from '../../../server/validationMethods';

const followUpDays={
    'FU-Phone':  2,
    'FU-Email': 2,
    'CM': 3,
    'Demo Scheduled':5,
    'Demo Done':2,
    'Quote Sent': 2,
    'Converted': 5
}
const newLeadCode=1;
const timePeriod={
    'TODAY':'Today',
    'ALLDAYS':'All Days'
}
const statusCategory={
    'New':['New','Not touched'],
    'In-Process':['FU-Phone','FU-Email','CM','Email sent','Call Done'],
    'Active':['Demo Scheduled','Demo Done','Quote Sent'],
    'ALL':['ALL'],
    'Converted':['Converted'],
    'On-Boarded':['Onboarded','Onboarding Complete / Active'],
    'Rejected':['Rejected Parent','Rejected Spam','Rejected Other','Rejected-Parent','Rejected-Spam','Rejected-Other'],
    'Lost':['Lost','Rejected Lost']
}


class LeadManagment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            search:'',
            expanded: {},
            statusData:[],
            leadsData:[],
            chagedRecords:{},
            owners:[],
            filterLeadsData:[],
            totalLength:0,
            filterState:statusCategory.ALL.join(','),
            filterTimePeriod:timePeriod.TODAY,
            showNewRec:false,
            newRec:{
                name:'',
                emailAddress:'',
                mobileNo:'',
                schoolName:''
            }
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.getLeadsStatus();        
    };
    
    getLeads=()=>{
        get(`/leads?status=${statusCategory.ALL.join(',')}&offset=0&limit=10000000&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            data.map(item => {
                //item.newComments='';
                if(!item.statusCodeId){
                    item.statusCodeId=newLeadCode;
                }
            })
            
            this.setState({
                leadsData: data,
                totalLength: data.length,
                loading: false
            },()=>{
                this.filterData();
            })
        }).catch(
            (error) => {
                console.log('Get Leads response', error)
            }
        );
    }
    filterData=()=>{
        const {leadsData, search,filterState,filterLeadsData, filterTimePeriod}=this.state;
        
        const _changePendingRecs=filterLeadsData.filter(itm=>{
            return itm.contentChanged
        }).map(itm=>itm.requestId);
        const periodFilterData=[];
        let statusFilterData=[];
        const filterData=[];

        if(filterTimePeriod===timePeriod.ALLDAYS){
            const periodFilterData=[...leadsData];
            if(filterState===statusCategory.ALL.join(',')){
                statusFilterData=[...periodFilterData];
            }else{
                statusFilterData=periodFilterData.filter(item=>{
                    const rec=this.state.statusData.find(itm=>{
                        return itm.statusCodeId==item.statusCodeId;
                    })
                    return filterState.split(',').includes((rec||{}).statusCodeDesc);
                })
            }
            statusFilterData.map(itm=>{
                if(_changePendingRecs.includes(itm.requestId)){
                    itm.contentChanged=true;
                }
            });
        }else if(filterTimePeriod===timePeriod.TODAY){
            if(filterState===statusCategory.ALL.join(',')){
                statusFilterData=leadsData.filter(lead=>{
                    if(moment(lead.followUpDate).isValid()){
                        if(moment(lead.followUpDate).format('YYYY-MM-DD')==moment().format('YYYY-MM-DD')){
                            return true;
                        }
                        return false;
                    }else{
                        if(moment(lead.createdOn).format('YYYY-MM-DD')==moment().format('YYYY-MM-DD')){
                            return true;
                        }
                        return false;
                    }
                });
            }else if(filterState===statusCategory.New.join(',')){
                statusFilterData=leadsData.filter(lead=>{
                    const rec=this.state.statusData.find(itm=>{
                        return itm.statusCodeId==lead.statusCodeId;
                    })                    
                    return filterState.split(',').includes((rec||{}).statusCodeDesc) && moment(lead.createdOn).format('YYYY-MM-DD')==moment().format('YYYY-MM-DD') 
                });
            }else{
                statusFilterData=leadsData.filter(lead=>{
                    const rec=this.state.statusData.find(itm=>{
                        return itm.statusCodeId==lead.statusCodeId;
                    })                    
                    return filterState.split(',').includes((rec||{}).statusCodeDesc) && moment(lead.followUpDate).isValid()  && moment(lead.followUpDate).format('YYYY-MM-DD')==moment().format('YYYY-MM-DD') 
                });

            }
        }
        if(search.length>0){
            statusFilterData.forEach(item=>{
                if((item.schoolName||'').toLowerCase().includes(search.toLowerCase())){
                    filterData.push({...item});
                }
                else if((item.name||'').toLowerCase().includes(search.toLowerCase())){
                    filterData.push({...item});
                }
                else if((item.emailAddress||'').toLowerCase().includes(search.toLowerCase())){
                    filterData.push({...item});
                }
                else if((item.mobileNo||'').includes(search.toLowerCase())){
                    filterData.push({...item});
                }
            });
            this.setState({filterLeadsData:filterData});
        }else{
            this.setState({filterLeadsData:statusFilterData})
        }
    }
    getLeadsStatus=()=> {
        this.setState({ loading: true });
        get(`/leads/status?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({ statusData: data.sort((a, b)=> {
                var nameA = a.statusCodeDesc.toUpperCase();
                var nameB = b.statusCodeDesc.toUpperCase();
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              }), loading: false },()=>{
                this.getOwnersList();                
              })
        }).catch(error => {
            this.setState({ loading: false },()=>{
                this.getOwnersList();
            });
            console.log("Loading Failed", error)
        })
    };
    getOwnersList=()=>{        
        this.setState({ loading: true });
        get(`/superAdminUsers?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({ owners: (data._embedded.superAdminUsers||[]).sort((a, b)=> {
                var nameA = `${a.firstName} ${a.lastName}`.toUpperCase();
                var nameB = `${b.firstName} ${b.lastName}`.toUpperCase();
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              }), loading: false },()=>{
                this.getLeads();
            })
        }).catch(error => {
            this.setState({ loading: false, owners:[] },()=>{
                this.getLeads();
            });
            console.log("Loading Failed", error)
        })
    }
    handleChange=(e, row, fieldName)=> {
        const newObj = JSON.parse(JSON.stringify(this.state.filterLeadsData))       
        newObj[row._index][fieldName] = e.target.value
        if(fieldName==='statusCodeId'){
            const rec=this.state.statusData.find(itm=>{
                return itm.statusCodeId==e.target.value;
            })
            if(rec){
                let days=followUpDays[rec.statusCodeDesc]||0;
                if(days>0){
                    newObj[row._index]['followUpDate'] = moment().add(days,'d').format('YYYY-MM-DD');
                }else{
                    newObj[row._index]['followUpDate']=undefined;
                }
            }
        }
        const isChanged=this.isRecordChanged(newObj[row._index]);
        newObj[row._index]['contentChanged']=isChanged;
        this.setState({ filterLeadsData: newObj });
    }
    datehandleChange=(date, row, fieldName)=> {
        console.log(row);
        const newObj = JSON.parse(JSON.stringify(this.state.filterLeadsData))
        const newDate = date
        newObj[row._index][fieldName] = newDate? moment(newDate).format('YYYY-MM-DD'):undefined;
        const isChanged=this.isRecordChanged(newObj[row._index]);
        newObj[row._index]['contentChanged']=isChanged;
        this.setState({ filterLeadsData: newObj });
    }
    saveLeadDetails = (row) => {
        const {filterLeadsData}=this.state;
        let _leads = row;
        this.setState({ loading: true });
        let requestData = {}
        const loggedUser = sessionStorage.getItem('loggedInUserInfo') || '';

        requestData = {
            "requestId": _leads.requestId,
            "comments": _leads.comments,
            "emailAddress":_leads.emailAddress,
            "followUpDate":_leads.followUpDate,
            "mobileNo":_leads.mobileNo,
            "name":_leads.name,
            "schoolName":_leads.schoolName,
            "statusCodeId":_leads.statusCodeId,
            "ownerName":_leads.ownerName,
            "loggedUser":loggedUser
        }
        put('/leads?access_token=', JSON.stringify(requestData))
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((data) => {
                _addNotification('Successfully updated Lead details.', this);
                const _filterLeadsData=filterLeadsData.map(itm=>{
                    if(itm.requestId==_leads.requestId){
                        itm.contentChanged=false;
                    }
                    return itm;
                })
                this.setState({ loading: false,filterLeadsData:_filterLeadsData});
                this.getLeads();
                
            }).catch(error => {
                this.setState({ loading: false });
                _addNotificationError('Could not updated Lead details.', this);
                console.log('update lead response', error)
            });
    }
    renderNewRec=()=>{
        const {newRec}=this.state;        
        const onChange=(e)=>{
            const _newRec={...this.state.newRec};
            _newRec[e.target.name]=e.target.value;
            this.setState({newRec:_newRec});
        }
        const handleSubmit=(e)=>{
            e.preventDefault();
            this.newRecForm.validateAll();
            if(isValidForm(this.newRecForm)){
                saveRec();
            }else{
            }
        }
        const saveRec=()=>{
            const loggedUser = sessionStorage.getItem('loggedInUserInfo') || '';
            this.setState({ loading: true });
            const reqBody={...this.state.newRec};
            reqBody['loggedUser']=loggedUser;
            let headers = {
                'Content-Type': 'application/json'
            };
            
            postWithHeaders('/demoRequests?access_token=', JSON.stringify(reqBody),headers)
            .then((response) => {
                if (response.status !== 201) {
                    throw Error(response.statusText);
                }
                return response;
            }).then(data => {
                _addNotification('Record Added Successfully.', this);
                this.setState({showNewRec:false, loading:false, newRec:{name:'', emailAddress:'', mobileNo:'',schoolName:''}},()=>{
                    this.getLeads();
                });
                
            }).catch(
                (error) => {
                    _addNotificationError('Failed to create new lead.', this);
                    this.setState({loading:false});
                }
            );

        }
        return(
            <Form ref={(f)=>this.newRecForm=f} onSubmit={handleSubmit.bind(this)}>
                <div className="row" style={{ border: 'solid 1px #d7d7d7', borderRadius: '3px', margin: '1px', background: '#e9f1f9'}}>
                    <div className="form-group col-md-3">
                        <label htmlFor="txtName">Name*</label>
                        <Input type="text" name="name" value={newRec.name} onChange={(e)=>{onChange(e)}} 
                        className="form-control" id="txtName" placeholder="Name"
                        validations={[required]} 
                        requiredmsg='Please enter name.'
                        />
                    </div>
                    <div className="form-group col-md-2">
                        <label htmlFor="txtEmail">Email*</label>
                        <Input type="text" name="emailAddress" value={newRec.emailAddress} 
                        onChange={(e)=>{onChange(e)}} className="form-control" id="txtEmail" 
                        validations={[required, email]}  placeholder="Email"
                        requiredmsg='Please enter email id.'
                        />
                    </div>
                    <div className="form-group col-md-2">
                        <label htmlFor="txtPhone">Phone</label>
                        <Input type="text" name="mobileNo" value={newRec.mobileNo} 
                        onChange={(e)=>{onChange(e)}} className="form-control" id="txtPhone" placeholder="Phone (optional)"
                        //validations={[required, phone]} 
                        //requiredmsg='Please enter mobile no.' 
                        />
                    </div>
                    
                    <div className="form-group col-md-3">
                        <label htmlFor="txtSchool">School Name</label>
                        <Input type="text" name="schoolName" value={newRec.schoolName} 
                        onChange={(e)=>{onChange(e)}} className="form-control" id="txtSchool" placeholder="School Name (optional)"
                        //validations={[required]} 
                        //requiredmsg='Please enter school name.' 
                        />
                    </div>
                    <div className="form-group col-md-2" style={{margin:'24px auto 0px auto'}}>
                        <button type="submit" className="btn btn-success" style={{margin:'0px 5px'}}>Save</button>
                        <button type="button" className="btn btn-danger" style={{margin:'0px 5px'}} onClick={()=>{
                            this.setState({showNewRec:false, newRec:{name:'', emailAddress:'', mobileNo:'',schoolName:''}});
                        }}>Cancel</button>
                    </div>
                </div>
            </Form>
        )
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input 
                style={{ position: 'relative', border: 'ridge', zIndex: 'auto' }} 
                {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    renderSummaryPan=()=>{
        const {leadsData, statusData}=this.state;
        const groupByStatusIds=groupBy(statusData,'statusCodeId');
        let newLeads=[];
        let followDue=0;
        let activeList=0;
        newLeads=leadsData.filter(itm=>{
            const statusText=((groupByStatusIds[itm.statusCodeId]||[])[0]||{}).statusCodeDesc||'';
            return statusCategory.New.includes(statusText);
        });
        activeList=leadsData.filter(itm=>{
            const statusText=((groupByStatusIds[itm.statusCodeId]||[])[0]||{}).statusCodeDesc||'';
            return statusCategory.Active.includes(statusText);
        });
        followDue=leadsData.filter(itm=>{
            const statusText=((groupByStatusIds[itm.statusCodeId]||[])[0]||{}).statusCodeDesc||'';
            return (statusCategory.Converted.includes(statusText)|| statusCategory.Active.includes(statusText)|| statusCategory['In-Process'].includes(statusText));
        });
        return (
            <div className="row">
                <div className="col-md-offset-1 col-md-3">
                    <div className="input-group">
                        <span className="input-group-addon" >New Leads:</span>
                        <span className="form-control" 
                        style={{background: '#eeeeee', fontWeight: 'bold', textAlign:'center'}} >{newLeads.length}</span>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input-group">
                        <span className="input-group-addon" >Follow Due:</span>
                        <span className="form-control" 
                        style={{background: '#eeeeee', fontWeight: 'bold', textAlign:'center'}} >{followDue.length}</span>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="input-group">
                        <span className="input-group-addon" >Active:</span>
                        <span className="form-control" 
                        style={{background: '#eeeeee', fontWeight: 'bold', textAlign:'center'}} >{activeList.length}</span>
                    </div>
                </div>
                <div className="col-md-2 text-right">
                    <button className="btn btn-success" style={{margin:'0px 5px'}} onClick={()=>{
                        this.setState({showNewRec:true, newRec:{name:'', emailAddress:'',mobileNo:'',schoolName:''}});
                    }}>Create Lead</button>
                </div>
            </div>
        )
    }
    clearRowComment=(row)=>{
        const newObj = JSON.parse(JSON.stringify(this.state.filterLeadsData))       
        newObj[row._index]['comments']=''; 
        const isChanged=this.isRecordChanged(newObj[row._index]);
        newObj[row._index]['contentChanged']=isChanged;       
        this.setState({ filterLeadsData: newObj });       
    }
    refreshRowComment=(row)=>{
        const {leadsData}=this.state;
        const originalRec=leadsData.find(itm=>{
            return itm.requestId===row._original.requestId
        }); 
        if(originalRec){
            const newObj = JSON.parse(JSON.stringify(this.state.filterLeadsData))       
            newObj[row._index]['comments']=originalRec['comments'];  
            const isChanged=this.isRecordChanged(newObj[row._index]);
            newObj[row._index]['contentChanged']=isChanged;      
            this.setState({ filterLeadsData: newObj });
        }        
    }
    isRecordChanged=(rec)=>{
        let isChanged=false;
        const {leadsData}=this.state;
        const originalRec=leadsData.find(itm=>{
            return itm.requestId===rec.requestId
        });
        if(originalRec){
            if((originalRec.statusCodeId||newLeadCode)!== numberParce(rec.statusCodeId)){
                isChanged=true;
            }else if((originalRec.followUpDate||'')!== (rec.followUpDate||'')){
                isChanged=true;
            }else if((originalRec.comments||'') !==(rec.comments||'')){
                isChanged=true;
            }else if((originalRec.ownerName||'')!==(rec.ownerName||'')){
                isChanged=true;
            }
        }
        return isChanged;
    }
    isPendingSaveChanges=()=>{
        let havingChanges=false;
        const {filterLeadsData}=this.state;
        havingChanges=filterLeadsData.some(itm=>{
            return itm.contentChanged===true;
        })
        return havingChanges;
    }
    showSavePendingChangesMsg=()=>{
        _addNotificationError('Please save pending changes.',this);
    }

    render() {
        const { toggleSelection, toggleAll, isSelected } = this;
        const { statusData,commentsData, search, filterLeadsData, loading, owners, showNewRec} = this.state;
        const today = new Date();
        const yesterday = moment().subtract(1, 'day');
        const disablePastDt = current => {
            return current.isAfter(yesterday);
        };
        const checkboxProps = {
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold', textAlign:'right'
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    style: {
                        margin: 'auto !important'
                    },
                    className: "table table-hover"
                }
            },
        };
        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className='sweet-loading'
                        style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={loading}
                        />
                    </div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className=" pull-left sectionTitle">
                                    <h2 style={{ margin: '20px 0px 0px' }}>
                                        <span style={{ margin: '10px 10px 0px 0px' }}>Lead Management</span>
                                    </h2>
                                </div>                                
                                <div className="pull-right">
                                <div id="selector1" className="btn-group pull-left"
                                        style={{ margin: '7px 20px 0px', display: 'block' }}> 
                                <button type="button" className={this.state.filterTimePeriod===timePeriod.TODAY?'btn btn-xs btn-inactive-color active':'btn btn-xs btn-inactive-color'}
                                            id={timePeriod.TODAY} onClick={() => {
                                                if(this.isPendingSaveChanges()){
                                                    this.showSavePendingChangesMsg();                                                    
                                                    return false
                                                }
                                                this.setState({filterTimePeriod:timePeriod.TODAY, expanded:{}},()=>{this.getLeads()})}
                                            }
                                        >{timePeriod.TODAY}
                                        </button>  
                                        <button type="button" className={this.state.filterTimePeriod===timePeriod.ALLDAYS?'btn btn-xs btn-inactive-color active':'btn btn-xs btn-inactive-color'}
                                            id={timePeriod.ALLDAYS} onClick={() => {
                                                if(this.isPendingSaveChanges()){
                                                    this.showSavePendingChangesMsg();                                                    
                                                    return false
                                                }
                                                this.setState({filterTimePeriod:timePeriod.ALLDAYS, expanded:{}},()=>{this.getLeads()})}
                                            }
                                        >{timePeriod.ALLDAYS}
                                        </button> 
                                        </div>
                                        
                                
                                    <div id="selector" className="btn-group pull-right"
                                        style={{ margin: '7px 0px 0px', display: 'block' }}> 
                                                         
                                        <button type="button" className={this.state.filterState===statusCategory.New.join(',')?'btn btn-xs btn-inactive-color active':'btn btn-xs btn-inactive-color'}
                                            id="New" onClick={() => {
                                                if(this.isPendingSaveChanges()){
                                                    this.showSavePendingChangesMsg();                                                    
                                                    return false
                                                }
                                                this.setState({filterState:statusCategory.New.join(','), expanded:{}},()=>{this.getLeads()})}
                                            }
                                        >New
                                        </button>
                                        <button type="button" className={this.state.filterState===statusCategory['In-Process'].join(',')?'btn btn-xs btn-inactive-color active':'btn btn-xs btn-inactive-color'}
                                            id="In-Process" onClick={() => {
                                                if(this.isPendingSaveChanges()){
                                                    this.showSavePendingChangesMsg();                                                    
                                                    return false
                                                }
                                                this.setState({filterState:statusCategory['In-Process'].join(','), expanded:{}},()=>{this.getLeads()})}}
                                        >In-Process
                                        </button>
                                        <button type="button" className={this.state.filterState===statusCategory['Active'].join(',')?'btn btn-xs btn-inactive-color active':'btn btn-xs btn-inactive-color'}
                                            id="Active" onClick={() => {
                                                if(this.isPendingSaveChanges()){
                                                    this.showSavePendingChangesMsg();                                                    
                                                    return false
                                                }
                                                this.setState({filterState:statusCategory['Active'].join(','), expanded:{}},()=>{this.getLeads()})}}
                                        >Active
                                        </button>                                        
                                        <button type="button" className={this.state.filterState===statusCategory['ALL'].join(',')?'btn btn-xs btn-inactive-color active':'btn btn-xs btn-inactive-color'}
                                            id="allLeads" onClick={() => {
                                                if(this.isPendingSaveChanges()){
                                                    this.showSavePendingChangesMsg();                                                    
                                                    return false
                                                }
                                                this.setState({filterState: statusCategory['ALL'].join(','), expanded:{}},()=>{this.getLeads()})}}
                                            
                                        >All Leads
                                        </button>
                                        <button type="button" className={this.state.filterState===statusCategory['Converted'].join(',')?'btn btn-xs btn-inactive-color active':'btn btn-xs btn-inactive-color'}
                                             id="Converted" onClick={() => {
                                                if(this.isPendingSaveChanges()){
                                                    this.showSavePendingChangesMsg();                                                    
                                                    return false
                                                }
                                                 this.setState({filterState:statusCategory['Converted'].join(','), expanded:{}},()=>{this.getLeads()})}}
                                        >Converted
                                        </button>
                                        <button type="button" className={this.state.filterState===statusCategory['On-Boarded'].join(',')?'btn btn-xs btn-inactive-color active':'btn btn-xs btn-inactive-color'}
                                             id="On-Boarded" onClick={() => {
                                                if(this.isPendingSaveChanges()){
                                                    this.showSavePendingChangesMsg();                                                    
                                                    return false
                                                }
                                                 this.setState({filterState:statusCategory['On-Boarded'].join(','), expanded:{}},()=>{this.getLeads()})}}
                                        >On-Boarded
                                        </button>
                                        <button type="button" className={this.state.filterState===statusCategory.Rejected.join(',')?'btn btn-xs btn-inactive-color active':'btn btn-xs btn-inactive-color'}
                                             id="Rejected" onClick={() => {
                                                if(this.isPendingSaveChanges()){
                                                    this.showSavePendingChangesMsg();                                                    
                                                    return false
                                                }
                                                 this.setState({filterState:statusCategory.Rejected.join(','), expanded:{}},()=>{this.getLeads()})}}
                                        >Rejected
                                        </button>
                                        <button type="button" className={this.state.filterState===statusCategory.Lost.join(',')?'btn btn-xs btn-inactive-color active':'btn btn-xs btn-inactive-color'}
                                             id="Lost" onClick={() => {
                                                if(this.isPendingSaveChanges()){
                                                    this.showSavePendingChangesMsg();                                                    
                                                    return false
                                                }
                                                 this.setState({filterState:statusCategory.Lost.join(','), expanded:{}},()=>{this.getLeads()})}}
                                        >Lost
                                        </button>
                                       
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="clearfix"></div>
                                <div className="panel panel-primary">
                                    <div className="panel-body">
                                        <div className="row" style={{paddingBottom:'5px'}}>
                                            <div className="col-md-3">
                                                <input type="text" className="form-control" value={search} placeholder="Search" onChange={(e)=>{
                                                    this.setState({search:e.target.value},()=>{
                                                        this.filterData();
                                                    })
                                                }} />
                                            </div>
                                            <div className="col-md-9">
                                                {
                                                    this.renderSummaryPan()
                                                }
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                {
                                                  showNewRec &&  this.renderNewRec()
                                                }
                                            </div>
                                        </div>
                                        <div className="row">                                            
                                            <div className="col-md-12">                                                
                                                <div className="leadsTable">
                                    <ReactTable 
                                        data={filterLeadsData}
                                        expanded={this.state.expanded}
                                        columns={[
                                            {
                                                Header: "Lead",
                                                id: "lead",
                                                width: 275,
                                                Cell: ({ row }) => {
                                                return <Fragment>
                                                        <div className="leadName">{row._original.name||''}</div>
                                                        {(row._original.emailAddress||'')!=='' && <div className="lead-Email-phone"><i className="fa fa-envelope-o"></i>: {row._original.emailAddress||''}</div>}
                                                        {(row._original.mobileNo||'')!==''&& <div className="lead-Email-phone"><i className="fa fa-mobile"></i>: {row._original.mobileNo||''}</div>}
                                                </Fragment>
                                                },
                                            },
                                            {
                                                Header:'Source',
                                                width:100,
                                                accessor:'source'

                                            },
                                            {
                                                Header: "School",
                                                width: 200,
                                                accessor: "schoolName",
                                                id: "schoolName",
                                                style: { textAlign: 'left', whiteSpace: 'unset' },
                                                Cell: ({ row }) => {
                                                return <span>{row._original.schoolName||''}</span>
                                                }
                                            },
                                            {
                                                Header: "Status",
                                                accessor: "statusCodeId",
                                                width: 150,
                                                style: { textAlign: 'center'},
                                                Cell: ({ row }) => {
                                                   
                                                return <select className='form-control' value={row.statusCodeId||''}
                                                    onChange={(e) => this.handleChange(e, row, "statusCodeId")}
                                                >
                                                    <option value='' >Select</option>
                                                    {
                                                        (statusData || []).map((key) => {
                                                            return (<option value={key.statusCodeId}>{key.statusCodeDesc}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                },
                                                filterMethod: (filter, row) => {
                                                    const _row = row._original
                                                    let selectedIds = []
                                                    statusData.forEach(item => {
                                                        if (item.statusCodeDesc.toLowerCase().startsWith(filter.value.toLowerCase())) {
                                                            selectedIds.push(item.statusCodeId)
                                                        }
                                                    })
                                                    return selectedIds.length > 0 ? selectedIds.includes(_row.statusCodeId) : false
                                                },
                                            },
                                            {
                                                Header: "Follow Up Date",
                                                accessor: "followUpDate",
                                                width: 160,
                                                style: { textAlign: 'center',overflow: 'initial'},
                                                Cell: ({ row }) => (
                                                <Fragment>
                                                    <DatePicker className='form-control' ref='startCalendar'
                                                    dateFormat={'MM-dd-yyyy'}
                                                        selected={row.followUpDate? moment(row.followUpDate,'YYYY-MM-DD').toDate():null} 
                                                        placeholderText='MM-DD-YYYY'
                                                        onChange={(date) =>{
                                                            this.datehandleChange(date, row, "followUpDate")
                                                            //setStartDate(date)

                                                        } } 
                                                    />
                                                    {/* <div className="uploadFileInfo  createmenu-month-group form-group">
                                                    <div className="input-group " style={{ zIndex: 'auto' }}>
                                                         <Datetime ref='startCalendar'
                                                          style={{ position: 'inherit !important'}}
                                                            dateFormat={'MM-DD-YYYY'}
                                                            timeFormat={false}
                                                            //isValidDate={disablePastDt}
                                                            selected={new Date()}
                                                            //minDate={moment().toDate()}
                                                            closeOnSelect={true} 
                                                            value={ moment(row.followUpDate,'YYYY-MM-DD')}
                                                            onChange={(e) => {
                                                                this.datehandleChange(e, row, "followUpDate")
                                                                //this.refs.startCalendar.closeCalendar()
                                                            }}
                                                            renderInput={this.renderInput} /> 
                                                    </div>
                                                </div> */}
                                            </Fragment>)
                                            },
                                            {
                                                Header: "Comments",
                                                accessor: "comments",
                                                style: { textAlign: 'center'},
                                                Cell: ({ row }) => {
                                                    return (
                                                        <div className='commentPan'>
                                                            <div className='commentActionPan'>
                                                                <span className="commentBtn refresh" name="Undo Comment" onClick={()=>{
                                                                    this.refreshRowComment(row);
                                                                }
                                                            }><i className='fa fa-refresh'></i></span>
                                                                <span className="commentBtn clear" name="Clear Comment" onClick={()=>{
                                                                    this.clearRowComment(row);
                                                                }
                                                            }><i className='fa fa-times'></i></span>                                                                
                                                            </div>
                                                            <textarea type="text" className="form-control col-xs" 
                                                                value={row._original.comments||''} 
                                                                onChange={(e) => this.handleChange(e, row, "comments")} />                                                            
                                                        </div>
                                                    )
                                                }
                                            },
                                            {
                                                Header: "Owner",
                                                width: 150,
                                                style: { textAlign: 'center'},
                                                Cell: ({ row }) => {                                                   
                                                    return <select className='form-control' value={row._original.ownerName||''}
                                                        onChange={(e) => this.handleChange(e, row, "ownerName")}
                                                    >
                                                        <option value='' >Select</option>
                                                        {
                                                            (Object.values(owners || {})).map((key) => {
                                                                return (<option value={`${key.firstName} ${key.lastName}`}>{`${key.firstName} ${key.lastName}`}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                    },
                                            },
                                            {
                                                Header: "Date Of Lead",
                                                accessor: "createdOn",
                                                id: "createdOn",
                                                width: 120,
                                                style: { textAlign: 'center'},
                                                Cell: ({ row }) => <span>{moment(row._original.createdOn).format('MM-DD-YYYY')}</span>,
                                                filterMethod: (filter, row) => {
                                                    const _row = row._original
                                                    return _row.createdOn ? (moment(_row.createdOn).format('YYYY-MM-DD')).toLowerCase().startsWith(filter.value.toLowerCase()) : false
                                                },
                                            },
                                            {
                                                Header: "Action",
                                                width: 70,
                                                style: { textAlign: 'center', border: '1px solid transpatent' },
                                                Cell: ({ row }) => {
                                                    const _chagedRecords=this.state.chagedRecords;
                                                    return(<Fragment><span style={{ textAlign: 'center' }}><button
                                                    onClick={() => {
                                                        console.log(row)
                                                        this.saveLeadDetails(row._original)
                                                    }}
                                                    className={row._original.contentChanged ?"btn btn-danger": "btn btn-success"}
                                                   //className="btn btn-success"
                                                    style={{ padding: '3px',
                                                        margin: '4px' }}>Save</button></span></Fragment>);
                                                }
                                            }
                                        ]}
                                        defaultPageSize={50}
                                        className="-striped -highlight"
                                        noDataText='No data found'
                                        minRows={1}
                                        showPagination={true}
                                        {...checkboxProps}
                                        onExpandedChange={expandedList => {
                                            const expanded = {}
                                            Object.keys(expandedList).forEach(item => {
                                                const expand = Boolean(expandedList[item] && expandedList[item].constructor === Object)
                                                expanded[item] = expand
                                            })
                                            this.setState({ expanded })
                                        }}
                                        SubComponent={(row) => {
                                            return (<LeadDetails row={row} data={statusData}/>)
                                        }}
                                    />
                                    </div>
                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        );
    }
}

export default LeadManagment;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Schools/leadManagment.jsx